import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  InlineStyleSnapshot,
  readInlineStyles,
  writeInlineStyles,
  getScrollPosition,
  setScrollPosition,
} from '../functions/style-utils';
import { BehaviorSubject } from 'rxjs';

export enum ElementLockType {
  ArrangementElement = 'arrangement-element',
  InvoiceHistoryTable = 'invoice-history-table',
}

export interface ElementLock {
  elementType: ElementLockType;
  status: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ScrollLockService {
  private bodySavedStyles: Record<string, InlineStyleSnapshot> | null = null;
  private bodySavedScroll = { x: 0, y: 0 };
  private bodyLockDepth = 0;
  private readonly bodyInlineProperties = [
    'padding-right',
    'overflow',
    'overflow-x',
    'overflow-y',
    'position',
    'top',
    'right',
    'bottom',
    'left',
    'width',
  ];

  private arrangementLockSource = new BehaviorSubject<ElementLock | null>(null);
  arrangementLock$ = this.arrangementLockSource.asObservable();

  private invoiceHistoryLockSource = new BehaviorSubject<ElementLock | null>(null);
  invoiceHistoryLock$ = this.invoiceHistoryLockSource.asObservable();

  private arrangementLockDepth = 0;
  private invoiceHistoryLockDepth = 0;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  arrangementLock() {
    // this.arrangementLockDepth += 1;
    // if (this.arrangementLockDepth > 1) {
    //   return;
    // }
    // this.arrangementLockSource.next({
    //   elementType: ElementLockType.ArrangementElement,
    //   status: true,
    // });
  }

  arrangementUnlock() {
    // if (this.arrangementLockDepth === 0) {
    //   return;
    // }
    // this.arrangementLockDepth = Math.max(0, this.arrangementLockDepth - 1);
    // if (this.arrangementLockDepth > 0) {
    //   return;
    // }
    // this.arrangementLockSource.next({
    //   elementType: ElementLockType.ArrangementElement,
    //   status: false,
    // });
  }

  invoiceHistoryLock() {
    // this.invoiceHistoryLockDepth += 1;
    // if (this.invoiceHistoryLockDepth > 1) {
    //   return;
    // }
    // this.invoiceHistoryLockSource.next({
    //   elementType: ElementLockType.InvoiceHistoryTable,
    //   status: true,
    // });
  }

  invoiceHistoryUnlock() {
    // if (this.invoiceHistoryLockDepth === 0) {
    //   return;
    // }
    // this.invoiceHistoryLockDepth = Math.max(0, this.invoiceHistoryLockDepth - 1);
    // if (this.invoiceHistoryLockDepth > 0) {
    //   return;
    // }
    // this.invoiceHistoryLockSource.next({
    //   elementType: ElementLockType.InvoiceHistoryTable,
    //   status: false,
    // });
  }

  bodyLock(): void {
    // const body = this.document?.body;
    // if (!body) {
    //   return;
    // }
    // this.bodyLockDepth += 1;
    // if (this.bodyLockDepth > 1) {
    //   return;
    // }
    // const docEl = this.document.documentElement;
    // const scrollbarWidth = Math.max(window.innerWidth - docEl.clientWidth, 0);
    // this.bodySavedStyles = readInlineStyles(body, this.bodyInlineProperties);
    // this.bodySavedScroll = getScrollPosition(window, this.document);
    // body.style.setProperty('top', `${-this.bodySavedScroll.y}px`, 'important');
    // body.style.setProperty('left', `${-this.bodySavedScroll.x}px`, 'important');
    // body.style.setProperty('right', '0', 'important');
    // body.style.setProperty('bottom', '0', 'important');
    // body.style.setProperty('width', '100%', 'important');
    // body.style.setProperty('overflow', 'hidden', 'important');
    // body.style.setProperty('position', 'fixed', 'important');
    // if (scrollbarWidth > 0 && Number.isFinite(scrollbarWidth)) {
    //   body.style.setProperty('padding-right', `${scrollbarWidth}px`, 'important');
    // }
  }

  bodyUnlock(): void {
    // const body = this.document?.body;
    // if (!body || this.bodyLockDepth === 0) {
    //   return;
    // }
    // this.bodyLockDepth = Math.max(0, this.bodyLockDepth - 1);
    // if (this.bodyLockDepth > 0) {
    //   return;
    // }
    // if (this.bodySavedStyles) {
    //   writeInlineStyles(body, this.bodySavedStyles);
    // }
    // this.bodySavedStyles = null;
    // setScrollPosition(window, this.bodySavedScroll);
    // this.bodySavedScroll = { x: 0, y: 0 };
  }
}
